interface CompanySectionProps {
  isReversed: boolean;
  imageId: string;
  imageSrc: string;
  children: React.ReactNode;
}

export const CompanySection = ({
  isReversed,
  imageSrc,
  imageId,
  children,
}: CompanySectionProps) => (
  <div className={`company-section company-item-${isReversed ? 'left' : 'right'}`}>
    <div
      className={`company-section-text company-item-${
        isReversed ? 'left' : 'right'
      }-text description`}
    >
      {children}
    </div>
    <div className="image-container" id={imageId} style={{ backgroundImage: `url(${imageSrc})` }} />
  </div>
);
